import { UserDto } from '../../api_client/parameter_api';
import { SET_USER_PROFILE, SET_USER, TOGGLE_USER_SETTINGS } from './actionTypes';

import { LoggedUser, ModalType } from '../../types';

export const setUserProfile = (profile: UserDto | null) => ({
  type: SET_USER_PROFILE,
  payload: { profile }
});

export const setUser = (user: LoggedUser | null) => ({ type: SET_USER, payload: { user } });

export const toggleUserSettings = (data: ModalType) => ({ type: TOGGLE_USER_SETTINGS, payload: { data } });
